import restfulBase from '@/services/negotiations/core/base';

export const addressesService = (companyId: string) =>
  restfulBase(`companies/${companyId}/addresses`);

export default addressesService;
